import http from '@/services/http';
import { error } from '@/utils/safetyLog';

export const getHeaderAndFooter = async (contentType: string, includeReference: string[], localLanguage: string) => {
  try {
    return await http({}).post(`/contentstack/${contentType}`, {
      queryObj: {},
      includeReference,
      language: localLanguage,
    });
  } catch (e) {
    error('getHeaderAndFooter error:', e);
    return { data: null }; // fallback to avoid undefined
  }
};
